var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopeCommunicationsFilled = function SvgEnvelopeCommunicationsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B7B7B7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.681 10 7.673 6.396.77.641 3.648 3.041 3.58-2.999.765-.642L29.8 10zM5 26.147l7.704-8.991L5 10.735zm17.77-8.952 7.71 8.95v-15.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73 26.832h24.022l-7.748-8.995-3.91 3.276h-.641l-3.98-3.316z"
  }))));
};
export { SvgEnvelopeCommunicationsFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNCN0I3QjciIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0ibTUuNjgxIDEwIDcuNjczIDYuMzk2Ljc3LjY0MSAzLjY0OCAzLjA0MSAzLjU4LTIuOTk5Ljc2NS0uNjQyTDI5LjggMTB6TTUgMjYuMTQ3bDcuNzA0LTguOTkxTDUgMTAuNzM1ek0yMi43NyAxNy4xOTVsNy43MSA4Ljk1VjEwLjczNXoiLz4KICAgICAgICA8cGF0aCBkPSJNNS43MyAyNi44MzJoMjQuMDIybC03Ljc0OC04Ljk5NS0zLjkxIDMuMjc2aC0uNjQxbC0zLjk4LTMuMzE2eiIvPgogICAgPC9nPgo8L3N2Zz4K";